import utils from '../utils';
//import customStyle from './map-style';

function init() {

	var maps = document.querySelectorAll('.google-maps-wrapper');

	if (maps.length > 0) {

		utils.forEach(maps, function (index, map) {
			
			var apiKey = JSON.parse(map.getAttribute('data-map')).api_key;

			utils.loadScript('https://maps.googleapis.com/maps/api/js?key=' + apiKey, false, function () {
				startMap(map);
			});

		});

	}
}

function startMap(map) {

    var mapDatas = JSON.parse(map.getAttribute('data-map')),
        markers = mapDatas.markers,
        //zoom = 15,
        maxZoom = 16,
        bounds = new window.google.maps.LatLngBounds();

    var defaultCenter = new window.google.maps.LatLng(43.7696, 11.2558); // Firenze

    var mapInstance = new window.google.maps.Map(map, {
        center: defaultCenter,  // Centra inizialmente su Firenze
        zoom: 7, // Zoom per visualizzare l'area intorno a Firenze
        disableDefaultUI: true,
    });

    mapInstance.setOptions({ maxZoom });

    var markerInstances = [];

    if (markers.length === 0) {
        console.warn("Nessun marker trovato, centrando su Firenze.");
    } else {
        for (let index = 0; index < markers.length; index++) {
            var marker = markers[index],
                latitude = parseFloat(marker.latitude),
                longitude = parseFloat(marker.longitude),
                link = marker.link,
                icon = marker.icon,
                markerLatLng = new window.google.maps.LatLng(latitude, longitude);

            var markerInstance = new window.google.maps.Marker({
                position: markerLatLng,
                map: mapInstance,
                icon: {
                    url: icon,
                    scaledSize: new window.google.maps.Size(60, 60),
                },
                url: link, 
            });

            markerInstances.push(markerInstance);
            bounds.extend(markerLatLng);

            markerInstances[index].addListener("click", () => {
                window.location.href = markerInstances[index].url;
            });
        }

        // Se c'è un solo marker, centro la mappa su quel marker
        if (markers.length === 1) {
            mapInstance.setCenter(bounds.getCenter());
            mapInstance.setZoom(15); // Zoom per un singolo marker
        } 
        // Se ci sono più marker, la mappa resta centrata su Firenze
        else {
            mapInstance.setCenter(defaultCenter);
            mapInstance.setZoom(6.5); // Zoom per visualizzare l'area tra i marker
        }
    }
}


export default { init };